export const environment = {
  production: false,
  urlAPI: 'https://uat-api-configurador.uecko.com/api/',
  blobPublic: 'https://blobueckomc.blob.core.windows.net/dev-uecko-public/'
};